<template>
  <div>
      <Card style="margin-top: 5px" :title="`总待结算金额: ${settleAmount} 结算订单数:${ids.length}`">
        <Form ref="editForm" :label-width="100" :model="formData">
          <FormItem label="打款日期" prop="pay_day">
            <Input v-model="formData.pay_day" placeholder="如2022-09-07" maxlength="100"></Input>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="formData.remark" placeholder="" maxlength="100"></Input>
          </FormItem>
        </Form>
      </Card>

      <div class="drawer-footer">
        <Button type="primary" @click="doSubmit">确定</Button>
      </div>
  </div>
</template>

<script>
  import config from '@/config/base-config'
  export default {
    name: "doSettle",
    props:{
      settleAmount:{
        type:Number,
        default: 0
      },
      ids:{
        type:Array,
        required:true,
        default: []
      }
    },
    data(){
      return {
        formData:{
          amount:'',
          remark:'',
          pay_day:'',
        },
      }
    },
    methods:{
      async doSubmit(){
        let _self = this;
        this.formData['ids'] = this.ids
        let res = await this.$commonFun.postProxy('admin/settlement/mutSettle',this.formData)
        //编辑成功刷新父页面
        this.$commonFun.dealApiResult(res,()=>{
          _self.$emit('mut-success')
          _self.$commonFun.successTip(res.msg,function () {
          })
        })
      },



    },
    mounted() {
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .info-item{
    >span:nth-child(1){
      min-width: 100px;
      display: inline-block;
      text-align: right;
      letter-spacing: 2px;
      padding: 2px;
    }
    >span:nth-child(2){
      display: inline-block;
      padding-left: 10px;
    }
    .important-word{
      font-weight: bold;
      color: red;
    }
  }

</style>
